import React, { useEffect, useRef, useState } from 'react';

export const StatNumber = ({ value, prefix = '', suffix = '', duration = 1000 }) => {
    const [count, setCount] = useState(0);
    const elementRef = useRef(null); // Reference to track this component

    useEffect(() => {
        if (!elementRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        let start = 0;
                        const end = Number(value) || 0;
                        const range = end - start;
                        const increment = range / (duration / 16); // Approximate smooth step

                        const animateCount = () => {
                            start = Math.min(start + increment, end);
                            setCount(Math.floor(start));

                            if (start < end) {
                                requestAnimationFrame(animateCount);
                            }
                        };

                        setCount(0); // Reset count on every view
                        requestAnimationFrame(animateCount);
                    }
                });
            },
            { threshold: 0.5 } // Trigger when 50% of the element is visible
        );

        observer.observe(elementRef.current);
        return () => observer.disconnect();
    }, [value, duration]); // Depend on value & duration to re-run effect

    return (
        <span className="stat-number" ref={elementRef}>
            {prefix}{count}{suffix}
        </span>
    );
};
